import * as React from "react";
import { useOutletContext } from "react-router";
import { DbAssetObjectInfos } from "../../../../../Core/Api/Types/db-asset-object-infos";
import DriveNavigateHandler, { DriveType } from "../../../../../Components/Drive/Common/drive-navigate-handler";

function AdminTitleDrive() {
  const { selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<DbAssetObjectInfos[]>>;
    selectedItems: DbAssetObjectInfos[];
  }>();

  return (
    <DriveNavigateHandler selectedItems={selectedItems} setSelectedItems={setSelectedItems} type={DriveType.Title} />
  );
}

export default AdminTitleDrive;
